import { render, staticRenderFns } from "./PublishSessionsGrid.vue?vue&type=template&id=58229fe2&"
import script from "./PublishSessionsGrid.vue?vue&type=script&lang=ts&"
export * from "./PublishSessionsGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports